<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.commission_reversal_default != ''}">
                                        <label for="commission_reversal_default" class="bmd-label-floating">Estorno Geral</label>
                                        <money v-model="form.commission_reversal_default" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div 
                                        class="form-group"
                                        v-bind:class="{'has-danger' : validation.logo != '' }">
                                        <file-upload
                                            class="btn btn-primary"
                                            :multiple="false"
                                            :size="1024 * 1024 * 10"
                                            v-model="files"
                                            @input-filter="inputFilter"
                                            @input-file="inputFile"
                                            ref="upload">
                                            <i class="fa fa-plus"></i>
                                            Selecione o Logo
                                        </file-upload>
                                        <label v-if="validation.logo != ''" id="logo-error" class="error" for="logo" style="clear: both; display: block;">{{ validation.logo }}</label>
                                    </div>
                                </div>
                            </div>
                              <div class="row">
                                <div class="col-md-8">
                                    <list-commissions :commissions="form.commissions" @pushLine='addLine' />
                                </div>
                                <div class="col-sm-2"></div>
                                <div class="col-sm-2"></div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'administrators.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Commission from '../../components/elements/commissions/Commission'
    export default {
        components : {
            'list-commissions' : Commission
        },
        data() {
            return {
                files: [],
                form: {
                    name: '',
                    commission_reversal_default: 0,
                    logo: {
                        name: '',
                        contentType: '',
                        content: ''
                    },
                    commissions:[],
                },
                percent: {
                    decimal: ',',
                    thousands: '',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                validation: {
                    name: '',
                    logo: ''
                }
            };
        },
        methods: {
            addLine(item){ this.form.commissions.push(item); },
            getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = () => resolve(window.btoa(reader.result));
                    reader.onerror = error => reject(error);
                });
            },
            inputFile(newFile, oldFile) {
                var form = this.form;
                const reader = new FileReader();

                form.logo = {
                    name: '',
                    contentType: '',
                    content: ''
                };
                if (newFile && !oldFile) {
                    const file = this.getBase64(newFile.file);
                   
                    file.then(function (data) {
                        form.logo = {
                            name: newFile.name,
                            contentType: newFile.type,
                            content: data
                        };
                    });
                }
                if (newFile && oldFile) {
                    // update
                    console.log('update', newFile)
                }
                if (!newFile && oldFile) {
                    // remove
                    console.log('remove', oldFile)
                }
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // 添加文件前
                    // Filter system files or hide files
                    // 过滤系统文件 和隐藏文件
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    // 过滤 php html js 文件
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },
            onSubmit(_ev) {
                var self = this;
                var valid = true;
                self.validation.name = '';
                self.validation.logo = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.logo.name == '') {
                    self.validation.logo = 'Campo obrigatório!';
                    valid = false;
                }
                // Remove elementos duplicados no momento do cadastro.
                self.form.commissions = self.form.commissions.filter((a) => { return !self[JSON.stringify(a.sequence)] && (self[JSON.stringify(a.sequence)] = true);}, Object.create(null));
            
                if (valid) 
                {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('administrators/add', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Administradora cadastrada com sucesso!");
                        self.$router.push({'name': 'administrators.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }

                            if (err.data.errors.logo !== undefined) {
                                self.validation.logo = err.data.errors.logo[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            }
        }
    };
</script>